// eslint-disable-next-line no-unused-vars
import React, { useState, useEffect, useRef } from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faTrash, faPlus, faCalendarAlt, faTimes } from '@fortawesome/free-solid-svg-icons'
import { fetchBrands, fetchMenu, meta } from '../../../fnc'
import Select from 'react-select';
import DayPicker from 'react-day-picker';
import 'react-day-picker/lib/style.css';
import moment from 'moment';
const refConst = require("../../../constants.js").v

const initialState = {
	_isMounted: false
}

// DatePickerButton component
function DatePickerButton({ date, label = "Date (Optional)", onDateChange, onDateClear }) {
	const [isOpen, setIsOpen] = useState(false);
	const calendarRef = useRef(null);
	const buttonRef = useRef(null);

	useEffect(() => {
		const handleClickOutside = (event) => {
			if (
				calendarRef.current &&
				buttonRef.current &&
				!calendarRef.current.contains(event.target) &&
				!buttonRef.current.contains(event.target)
			) {
				setIsOpen(false);
			}
		};

		if (isOpen) {
			document.addEventListener('mousedown', handleClickOutside);
			return () => {
				document.removeEventListener('mousedown', handleClickOutside);
			};
		}
	}, [isOpen]);

	const handleDateSelect = (selectedDate) => {
		if (selectedDate) {
			// Store date as ISO string for JSON serialization
			const dateString = moment(selectedDate).format('YYYY-MM-DD');
			onDateChange(dateString);
			setIsOpen(false);
		}
	};

	// Parse date - handle both string (YYYY-MM-DD) and Date object formats
	const displayDate = date ? moment(date).isValid() ? moment(date).format('MM/DD/YYYY') : null : null;
	const selectedDate = date && moment(date).isValid() ? moment(date).toDate() : null;

	return (
		<div className="mb-3 position-relative">
			<label className="font-weight-bold mb-2 d-block">{label}</label>
			<div className="d-flex align-items-center">
				<button
					ref={buttonRef}
					type="button"
					className="btn btn-outline-secondary"
					onClick={() => setIsOpen(!isOpen)}
					style={{ minWidth: '200px', textAlign: 'left' }}
				>
					<FontAwesomeIcon icon={faCalendarAlt} className="mr-2" />
					{displayDate || 'Select date'}
				</button>
				{date && (
					<button
						type="button"
						className="btn btn-outline-danger ml-2"
						onClick={onDateClear}
						title="Clear date"
					>
						<FontAwesomeIcon icon={faTimes} />
					</button>
				)}
			</div>
			{isOpen && (
				<div
					ref={calendarRef}
					className="position-absolute bg-white border rounded shadow-lg p-3"
					style={{
						zIndex: 1000,
						top: '100%',
						left: 0,
						marginTop: '5px'
					}}
				>
					<DayPicker
						selectedDays={selectedDate}
						onDayClick={handleDateSelect}
						month={selectedDate || new Date()}
						fromYear={2020}
						toYear={2030}
						captionLayout="dropdown"
					/>
				</div>
			)}
		</div>
	);
}

export default function SpecialBanner({ shopSelected, props }) {
	const [brands, setBrands] = useState([]);
	const [collections, setCollections] = useState([]);
	const [specialBanners, setSpecialBanners] = useState([]);
	const [metaId, setMetaId] = useState(null);

	const normalizeCollection = (collection) => {
		if(!collection) return { name: '', handle: '' };
		if(typeof collection === 'string') {
			return { name: collection, handle: '' };
		}

		const name = collection.name
			|| collection.title
			|| (collection.last && collection.last.name)
			|| collection.inline
			|| collection.label
			|| '';

		const handle = collection.handle
			|| collection.collection_handle
			|| collection.handle_collection
			|| collection.url_handle
			|| collection.slug
			|| '';

		return { name, handle };
	}

	const toHandleFallback = (input) => {
		if(!input) return '';
		return String(input)
			.trim()
			.toLowerCase()
			.normalize('NFKD')
			.replace(/[\u0300-\u036f]/g, '')
			.replace(/[^a-z0-9\s-]/g, '')
			.replace(/\s+/g, '-')
			.replace(/-+/g, '-');
	}

	useEffect(() => {
		initialState._isMounted = true;
		return () => initialState._isMounted = false
	}, [])

	useEffect(() => {
		if(!shopSelected || !shopSelected.id)	return;
		
		// Fetch brands
		props.loading(true);
		fetchBrands(shopSelected.id, { onlyActive: true }, null, (r) => {
			if(!initialState._isMounted)	return false
			console.info('Fetched brands for special banner:', r);
			if(r.success){
				setBrands(r.data || [])
			}
		});

		// Fetch collections
		fetchMenu({
			"shop": shopSelected.id,
			"menuOrNot": true
		}, null, (r) => {
			if(!initialState._isMounted)	return false
			console.info('Fetched collections for special banner:', r);
			if(r.success){
				setCollections(r.data || [])
			}
			props.loading(false);
		});

		// Fetch existing metafield
		meta.fetch({
			shop: shopSelected.id,
			namespace: "theme",
			key: "special_banners"
		}, (r) => {
			if(!initialState._isMounted)	return false
			console.info('Fetched special banners metafield:', r);
			if(r.success && r.res && r.res.length > 0){
				const metafield = r.res[0];
				setMetaId(metafield.id);
				try {
					const banners = JSON.parse(metafield.value);
					setSpecialBanners(Array.isArray(banners) ? banners : []);
				} catch(e) {
					console.error('Error parsing metafield value:', e);
					setSpecialBanners([]);
				}
			} else {
				setMetaId(null);
				setSpecialBanners([]);
			}
		});
	}, [shopSelected])

	const addBanner = () => {
		setSpecialBanners(prev => [...prev, {
			brands: [],
			collections: [],
			message: "",
			redirectToHandle: null,
			date_from: null,
			date_to: null
		}]);
	}

	const removeBanner = (index) => {
		setSpecialBanners(prev => prev.filter((_, i) => i !== index));
	}

	const updateBanner = (index, field, value) => {
		setSpecialBanners(prev => {
			const updated = [...prev];
			updated[index] = {
				...updated[index],
				[field]: value
			};
			return updated;
		});
	}

	const saveSpecialBanners = () => {
		if(!shopSelected || !shopSelected.id)	return;
		
		const bannersToSave = (specialBanners || []).map((banner) => {
			const cleaned = { ...(banner || {}) };
			if(!cleaned.redirectToHandle) delete cleaned.redirectToHandle;
			if(!cleaned.bgColor) delete cleaned.bgColor;
			if(!cleaned.textColor) delete cleaned.textColor;
			if(!cleaned.code || !String(cleaned.code).trim()) delete cleaned.code;
			return cleaned;
		});
		
		props.loading(true);
		meta.create({
			shop: shopSelected.id,
			namespace: "theme",
			key: "special_banners",
			value: bannersToSave
		}, (r) => {
			if(!initialState._isMounted)	return false
			console.info('Saved special banners metafield:', r);
			props.loading(false);
			if(r.success){
				if(r.json && r.json.id)	setMetaId(r.json.id);
				props.info({success: "Special banners saved successfully!"});
			} else {
				props.info({error: r.error || "Failed to save special banners"});
			}
		});
	}

	const getBrandOptions = () => {
		return brands.map(brand => {
			const brandName = brand.name || brand.brand_name || brand;
			return {
				value: brandName,
				label: brandName
			};
		});
	}

	const getCollectionOptions = () => {
		return collections.map(collection => {
			// Keep the existing behavior for filtering display (by name)
			const { name } = normalizeCollection(collection);
			return {
				value: name,
				label: name
			};
		}).filter(opt => opt.value); // Filter out empty values
	}

	const getRedirectCollectionOptions = () => {
		return collections.map(collection => {
			const { name, handle } = normalizeCollection(collection);
			const finalHandle = handle || toHandleFallback(name);
			return {
				value: finalHandle,
				label: name || finalHandle
			};
		}).filter(opt => opt.value);
	}

	return (
		<div className="border shadow rounded radius p-3 w-100 bg-light mt-4">
			<h5 className="mb-3">Special Banner Configuration</h5>
			<p className="text-muted mb-3">Configure special banners that appear for specific brands and collections</p>
			
			{/* List of banners */}
			{specialBanners.length > 0 && (
				<div className="mb-4">
					{specialBanners.map((banner, index) => (
						<div key={index} className="mb-4 p-3 border rounded bg-white">
							<div className="d-flex justify-content-between align-items-center mb-3">
								<h6 className="mb-0">Banner #{index + 1}</h6>
								<button
									className="btn btn-danger btn-sm"
									onClick={() => removeBanner(index)}
									title="Remove banner"
								>
									<FontAwesomeIcon icon={faTrash} />
								</button>
							</div>

							{/* Brands selection */}
							<div className="mb-3">
								<label className="font-weight-bold mb-2">Brands</label>
								<Select
									isMulti
									placeholder="Select brands..."
									options={getBrandOptions()}
									value={banner.brands?.map(brand => ({
										value: brand,
										label: brand
									})) || []}
									onChange={(selected) => {
										const brandValues = selected ? selected.map(s => s.value) : [];
										updateBanner(index, 'brands', brandValues);
									}}
									isSearchable={true}
									styles={{
										control: (base) => ({
											...base,
											minHeight: 38
										})
									}}
								/>
							</div>

							{/* Collections selection */}
							<div className="mb-3">
								<label className="font-weight-bold mb-2">Collections to appear on (optional)</label>
								<Select
									isMulti
									placeholder="Select collections..."
									options={getCollectionOptions()}
									value={banner.collections?.map(collection => ({
										value: collection,
										label: collection
									})) || []}
									onChange={(selected) => {
										const collectionValues = selected ? selected.map(s => s.value) : [];
										updateBanner(index, 'collections', collectionValues);
									}}
									isSearchable={true}
									styles={{
										control: (base) => ({
											...base,
											minHeight: 38
										})
									}}
								/>
							</div>

							{/* Redirect selection */}
							<div className="mb-3">
								<label className="font-weight-bold mb-2">Banner redirect (optional)</label>
								<Select
									placeholder="Select a collection to redirect to..."
									options={getRedirectCollectionOptions()}
									value={(() => {
										if(!banner.redirectToHandle) return null;
										const options = getRedirectCollectionOptions();
										return options.find(o => o.value === banner.redirectToHandle)
											|| { value: banner.redirectToHandle, label: banner.redirectToHandle };
									})()}
									onChange={(selected) => {
										updateBanner(index, 'redirectToHandle', selected ? selected.value : null);
									}}
									isClearable={true}
									isSearchable={true}
									styles={{
										control: (base) => ({
											...base,
											minHeight: 38
										})
									}}
								/>
								<small className="text-muted">When set, the banner becomes clickable and redirects to <code>/collections/&lt;handle&gt;</code>.</small>
							</div>

							{/* Message input */}
							<div className="mb-3">
								<label className="font-weight-bold mb-2">Message</label>
								<textarea
									className="form-control"
									rows="3"
									placeholder="Enter banner message..."
									value={banner.message || ""}
									onChange={(e) => updateBanner(index, 'message', e.target.value)}
								/>
							</div>

							{/* Promo code */}
							<div className="mb-3">
								<label className="font-weight-bold mb-2">Promo code (optional)</label>
								<input
									type="text"
									className="form-control"
									placeholder="e.g. SAVE10"
									value={banner.code || ""}
									onChange={(e) => {
										const nextValue = e.target.value;
										updateBanner(index, 'code', nextValue && String(nextValue).trim() ? nextValue : null);
									}}
								/>
							</div>

							{/* Colors */}
							<div className="mb-3">
								<div className="d-flex flex-row">
									<div className="flex-fill mr-3">
										<label className="font-weight-bold mb-2 d-block">Background color (OVERWRITE)</label>
										<div className="d-flex align-items-center">
											<input
												type="color"
												className="form-control mr-2"
												style={{width: '60px', height: '40px', padding: '2px', cursor: 'pointer'}}
												value={banner.bgColor || "#ffffff"}
												onChange={(e) => updateBanner(index, 'bgColor', e.target.value)}
											/>
											<span className="text-muted">{banner.bgColor || "#ffffff"}</span>
										</div>
									</div>
									<div className="flex-fill">
										<label className="font-weight-bold mb-2 d-block">Text color</label>
										<div className="d-flex align-items-center">
											<input
												type="color"
												className="form-control mr-2"
												style={{width: '60px', height: '40px', padding: '2px', cursor: 'pointer'}}
												value={banner.textColor || "#000000"}
												onChange={(e) => updateBanner(index, 'textColor', e.target.value)}
											/>
											<span className="text-muted">{banner.textColor || "#000000"}</span>
										</div>
									</div>
								</div>
								<small className="text-muted">Set the background color & text color only if you want something different from the default.</small>
							</div>

							{/* Date pickers */}
							<label className="font-weight-bold mb-2">Date Range (Optional)</label>
							<div className="alert alert-info p-2 mb-3" style={{ fontSize: '0.95rem' }}>
								Set the &quot;From Date&ldquo; to add the &quot;Starts in&ldquo; and set &quot;Until Date&ldquo; for &quot;Ends in&ldquo; text to the banner.
								<br />
								&quot;Until Date&ldquo; will have for effect to hide the banner once the date is reached.
							</div>
							<div className="d-flex flex-row">
								<div className="flex-fill mr-3">
									<DatePickerButton
										date={banner.date_from}
										label="From Date (Optional)"
										onDateChange={(date) => updateBanner(index, 'date_from', date)}
										onDateClear={() => updateBanner(index, 'date_from', null)}
									/>
								</div>
								<div className="flex-fill">
									<DatePickerButton
										date={banner.date_to}
										label="Until Date (Optional)"
										onDateChange={(date) => updateBanner(index, 'date_to', date)}
										onDateClear={() => updateBanner(index, 'date_to', null)}
									/>
								</div>
							</div>
						</div>
					))}
				</div>
			)}

			{/* Add new banner button */}
			<div className="mb-4">
				<button
					className="btn btn-outline-primary"
					onClick={addBanner}
					title="Add new banner"
				>
					<FontAwesomeIcon icon={faPlus} className="mr-2" />
					Add Banner
				</button>
			</div>

			{/* Submit button */}
			<div className="d-flex justify-content-end">
				<button
					className="btn btn-primary"
					onClick={saveSpecialBanners}
				>
					Save Special Banners
				</button>
			</div>

			{/* JSON preview (optional, for debugging) */}
			{/* We show the preview only for refConst.UID_system */}
			{specialBanners.length > 0 && refConst.UID_system === props.getUser().uid && (
				<div className="mt-4">
					<details>
						<summary className="text-muted cursor-pointer" style={{cursor: 'pointer'}}>Preview JSON</summary>
						<pre className="bg-dark text-light p-3 rounded mt-2" style={{maxHeight: '200px', overflow: 'auto'}}>
							{JSON.stringify(specialBanners, null, 2)}
						</pre>
					</details>
				</div>
			)}
		</div>
	);
}

